// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type AbfallartenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheAbfallartenQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheAbfallarten(): (
  query: SucheAbfallartenQuery
) => Promise<AbfallartenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) =>
      (await getAPI()).abfallarten.sucheAbfallarten({ ...query }),
    [getAPI]
  );
}
